import { render, staticRenderFns } from "./ForgotPasswordV2Component.vue?vue&type=template&id=51f698d8&scoped=true&"
import script from "./ForgotPasswordV2Component.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswordV2Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f698d8",
  null
  
)

export default component.exports